import React, { useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import styled from "styled-components";
import ExcelBtn from "../../../component/atoms/button/excelBtn";
import DatePicker from "../_components/datePicker";
import PretendardText from "../../../component/atoms/text/pretendardText";
import TableText from "./../../../component/atoms/text/table/tableText";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import TimeChart from "./_components/timeChart";
import getRandomInt from "../../../util/getRandomInt";

const StatisticsTime = () => {
  const [selectedDate, setSelectedDate] = useState("");

  const timeDummyData = [
    {
      time: "00시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "01시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "02시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "03시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "04시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "05시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "06시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "07시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "08시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "09시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "10시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "11시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "12시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "13시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "14시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "15시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "16시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "17시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "18시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "19시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "20시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "21시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "22시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
    {
      time: "23시",
      monthAverage: getRandomInt(1000),
      yesterday: getRandomInt(1000),
      today: getRandomInt(1000),
    },
  ];

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 30,
            }}
          >
            시간대별 조회수
          </TableTitle>

          <ContentHeader>
            <DatePicker
              dateType={"date"}
              isOnlyOneDate={true}
              onClick={() => {}}
              date={selectedDate}
              dateHandler={(date) => {
                setSelectedDate(date);
              }}
            />
            {/* <ExcelBtn /> */}
          </ContentHeader>

          <ContentContainer>
            <ChartContainer>
              <ChartHeader>
                <ChartHeaderText>차트 데이터</ChartHeaderText>
              </ChartHeader>
              <ChartGraphWrapper>
                <div
                  style={{
                    width: "fit-content",
                    height: 23,
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <span
                      style={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#cf6679",
                        borderRadius: "50%",
                      }}
                    />
                    <PretendardText
                      style={{
                        color: "#aaa",
                        fontSize: "14px",
                        fontWeight: 600,
                        lineHeight: "22.75px",
                      }}
                    >
                      6월 평균
                    </PretendardText>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <span
                      style={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#b658ff",
                        borderRadius: "50%",
                      }}
                    />
                    <PretendardText
                      style={{
                        color: "#aaa",
                        fontSize: "14px",
                        fontWeight: 600,
                        lineHeight: "22.75px",
                      }}
                    >
                      7월 7일
                    </PretendardText>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <span
                      style={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#34f3ff",
                        borderRadius: "50%",
                      }}
                    />
                    <PretendardText
                      style={{
                        color: "#aaa",
                        fontSize: "14px",
                        fontWeight: 600,
                        lineHeight: "22.75px",
                      }}
                    >
                      7월 8일
                    </PretendardText>
                  </div>
                </div>
              </ChartGraphWrapper>

              <TimeChart dataList={timeDummyData} />

              {/* 테이블 영역 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 50,
                  gap: 30,
                }}
              >
                <table
                  style={{
                    width: 435,
                    borderSpacing: 0,
                    borderCollapse: "collapse",
                  }}
                >
                  <colgroup>
                    {/* 합계: 435px */}
                    {/* 시간대 */}
                    <col width="57px" />
                    {/* 월 평균 */}
                    <col width="149px" />
                    {/* 어제 */}
                    <col width="104px" />
                    {/* 오늘 */}
                    <col width="125px" />
                  </colgroup>
                  <thead>
                    <tr
                      style={{
                        height: 41,
                        backgroundColor: "#313233",
                      }}
                    >
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            paddingLeft: 20,
                          }}
                        >
                          시간대
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                          }}
                        >
                          6월 평균
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                          }}
                        >
                          7월 7일
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                            marginRight: 20,
                          }}
                        >
                          7월 8일
                        </TableText>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(12)].map((_, index) => {
                      return (
                        <>
                          <tr
                            key={index}
                            style={{
                              height: 40,
                              borderBottom:
                                "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            <td>
                              <TableText
                                style={{
                                  paddingLeft: 20,
                                }}
                              >
                                {index > 9 ? `${index}` : `0${index}`}시
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                500
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                500
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                  marginRight: 20,
                                }}
                              >
                                {formatNumberWithCommas(2000)}
                              </TableText>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>

                <table
                  style={{
                    width: 435,
                    borderSpacing: 0,
                    borderCollapse: "collapse",
                  }}
                >
                  <colgroup>
                    {/* 합계: 435px */}
                    {/* 시간대 */}
                    <col width="57px" />
                    {/* 월 평균 */}
                    <col width="149px" />
                    {/* 어제 */}
                    <col width="104px" />
                    {/* 오늘 */}
                    <col width="125px" />
                  </colgroup>
                  <thead>
                    <tr
                      style={{
                        height: 41,
                        backgroundColor: "#313233",
                      }}
                    >
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            paddingLeft: 20,
                          }}
                        >
                          시간대
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                          }}
                        >
                          6월 평균
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                          }}
                        >
                          7월 7일
                        </TableText>
                      </th>
                      <th>
                        <TableText
                          style={{
                            fontWeight: "600",
                            lineHeight: "22.75px",
                            textAlign: "right",
                            marginRight: 20,
                          }}
                        >
                          7월 8일
                        </TableText>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(12)].map((_, index) => {
                      return (
                        <>
                          <tr
                            key={index}
                            style={{
                              height: 40,
                              borderBottom:
                                "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            <td>
                              <TableText
                                style={{
                                  paddingLeft: 20,
                                }}
                              >
                                {index + 12}시
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                500
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                }}
                              >
                                500
                              </TableText>
                            </td>
                            <td>
                              <TableText
                                style={{
                                  textAlign: "right",
                                  marginRight: 20,
                                }}
                              >
                                {formatNumberWithCommas(2000)}
                              </TableText>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </ChartContainer>
          </ContentContainer>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default StatisticsTime;

const ContentContainer = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const ContentHeader = styled.div.attrs((props) => {})`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ChartContainer = styled.div.attrs((props) => {})`
  width: 1044px;
  height: fit-content;
  min-height: 439px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  border-radius: 10px;
  background: #272829;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
`;

const ChartHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 30px;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const ChartHeaderText = styled(PretendardText).attrs((props) => {})`
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const ChartGraphWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 24px 30px;
`;
